<template>
  <div>
    <a v-if="isExternal(to)" :href="to" target="_blank" rel="noopener">{{ name }}</a>
    <a @click="goto(to)" v-else :class="name === $route.meta.parentName ? 'active' : ''">{{name}}</a>
    <!-- 认证弹窗 -->
    <!-- <Dialog :show="show" @dialogClose="show=false" :title="'温馨提示'" :img="'uncertified.png'" :content="'您还未进行身份认证，请先认证'" :btn="'去认证'"/> -->
  </div>
</template>
<script>
import Dialog from "@/components/Dialog";
export default {
  props: {
    to: String,
    name: String
  },
  components: {
    Dialog
  },
  data() {
    return {
      show: false
    };
  },
  methods: {
    isExternal(path) {
      return /^(https?:|mailto:|tel:)/.test(path);
    },
    goto(to) {
      // console.warn('tag', to)
      // if (!this.$store.state.token) {
      //   return this.$store.dispatch("getToken", "show");
      // } else {
        // this.$router.push(to);
        // if (this.$store.state.userInfo.personVertification || to == "/Home") {
          this.$router.push(to);
        // } else {
        //   this.$store.state.vertification = true;
        //   return false;
        // }
      // }
    }
  },
  mounted() {}
};
</script>
<style lang="scss" scoped>
.active {
  color: #22C686 !important;
  color: #ffc379 !important;
}
.active::after {
  content: "";
  position: absolute;
  left: 0;
  bottom: 0;
  width: 100%;
  height: 4px;
  background: #ffc379;
}
a {
  text-align: center;
  min-width: 60px;
  cursor: pointer;
  line-height: 48px;
  display: block;
  font-size: 14px;
  font-weight: 400;
  color: #222222;
  color: #fff;
  margin: 0 20px;
  padding: 0 10px;
  text-decoration: none;
  position: relative;
  &::before {
    content: " ";
    position: absolute;
    width: 1px;
    height: 12px;
    background: #ebecef;
    left: -20px;
    top: 50%;
    transform: translateY(-50%);
  }
  &:nth-of-type(1) {
    &::before {
      display: none;
    }
  }
}
.gotoDialog {
  /deep/ .el-dialog__header {
    display: none;
  }
  /deep/ .el-dialog__body {
    background: #f8f9fb;
  }
  p {
    margin-bottom: 20px;
    margin-left: 30px;
  }
  .option {
    display: flex;
    justify-content: space-around;
    margin-bottom: 20px;
    div {
      width: 220px;
      line-height: 100px;
      font-family: PingFangSC-Medium;
      font-size: 22px;
      letter-spacing: 0;
      text-align: center;
      border-radius: 2px;
      color: #000;
      background: #fff;
      box-shadow: 0px 5px 15px rgba(0, 0, 0, 0.1);
      cursor: pointer;
    }
    div:first-child {
      color: #22C686;
      margin-right: 10px;
    }
  }
}
</style>
